import React from "react";
import PropTypes from "prop-types";
import FormInput from "Common/Custom/FormInput";
import FormSubmitButton from "Common/Custom/FormSubmitButton";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";
import Switch from "Common/Custom/Switch";
import FormSelect from "Common/Custom/FormSelect";

const EditProductForm = ({
  fields = [],
  values = {},
  errors = {},
  handleChange = () => { },
  handleSubmit = () => { },
  loading = false,
  CategoryOPction = [],
  UOMOpction = [],
}) => {
  const renderField = (field) => {
    if (field.type === "switch") {
      return (
        <Switch
          key={field.name}
          field={field}
          values={values[field.name]}
          handleChange={handleChange}
          ValueOne="1"
          ValueTwo="0"
          LabelOne="Active"
          LabelTwo="Inactive"
        />
      );
    }

    if (field.type === "select") {
      let options = [];
      if (field.name === "category_id") {
        options = CategoryOPction.map((opt) => ({
          value: opt.category_id,
          label: opt.categoryname,
        }));
      } else if (field.name === "uom_id") {
        options = UOMOpction.map((opt) => ({
          value: opt.id,
          label: opt.uom_name,
        }));
      }
      return (
        <FormSelect
          key={field.name}
          field={field}
          value={values[field.name] ?? ""}
          handleChange={handleChange}
          options={options}
          error={errors[field.name]}
          disabled={field.disabled}
        />
      );
    }

    // Read-only stock display fields — shown with a muted style
    return (
      <FormInput
        key={field.name}
        field={field}
        value={values[field.name] ?? ""}
        handleChange={handleChange}
        error={errors[field.name]}
        disabled={field.disabled}
      />
    );
  };

  return (
    <PageBody
      headerchildren={<HeadingOne>Edit Product</HeadingOne>}
      onSubmit={handleSubmit}
    >
      {fields.map(renderField)}

      <FormSubmitButton
        label="Update"
        loading={loading}
        colSize="col-12"
        align="end"
      />
    </PageBody>
  );
};

EditProductForm.propTypes = {
  fields: PropTypes.array,
  values: PropTypes.object,
  errors: PropTypes.object,
  handleChange: PropTypes.func,
  handleSubmit: PropTypes.func,
  loading: PropTypes.bool,
  CategoryOPction: PropTypes.array,
  UOMOpction: PropTypes.array,
};

export default EditProductForm;
